import { ProviderAuthorization } from '../../interfaces';

export const meliAuthLink: ProviderAuthorization = {
    url: 'https://www.mercadolibre-auth-link.com',
};
